import { useEffect } from "react";
import { useTimeout } from "./UseTimeout";

// Custom Hook encargado de ejecutar la función callback cuando pasa el delay o cambian las dependencias
export const useDebounce = (callback, dependecies, delay = 300) => {
  const { reset, clear } = useTimeout(callback, delay);
  useEffect(reset, [...dependecies, reset]);
  useEffect(clear, []);
};
